import {InputLabel, FormControl, TextField, styled} from '@mui/material'
import {Colors} from 'appearance'
import {paramCase} from 'change-case'

const Input = ({
    label,
    dataTestId,
    height,
    width,
    style,
    variant,
    error,
    ...p
}) => {
    const inputVariant = variant || 'outlined'
    return (
        <FormControl variant={inputVariant} style={{width, ...style}} {...p}>
            {label && <Label variant={inputVariant}>{label}</Label>}
            <StyledInput
                error={!!error}
                height={height}
                variant={inputVariant}
                data-test-id={`input-${paramCase(
                    label || dataTestId || 'undefined'
                )}`}
                helperText={error}
                {...p}
            />
        </FormControl>
    )
}
export default Input

const StyledInput = styled(TextField)`
    direction: rtl;
    background: ${Colors.APP_WHITE};
    border-radius: 6px;
    height: ${({height}) => height || '35px'};
    & .MuiOutlinedInput-root {
        border-radius: 6px;
        height: ${({height}) => height || '35px'};
    }
    input::-webkit-outer-spin-button,
    input::-webkit-inner-spin-button {
        -webkit-appearance: none;
        margin: 0;
    }
    input[type='number'] {
        -moz-appearance: textfield;
    }
    input[type='file']::file-selector-button {
        display: none;
    }

    input[type='file']::-webkit-file-upload-button {
        display: none;
    }

    input[type='file']::-ms-browse {
        display: none;
    }
    & .MuiFormHelperText-root {
        text-align: right;
    }
`
const Label = styled(InputLabel)`
    top: -8px;
`
